module.exports = __webpack_public_path__ + "img/1000BS-logo.6ac7f738.png";